import { render, staticRenderFns } from "./BaseUserForm.vue?vue&type=template&id=16189e2a"
import script from "./BaseUserForm.vue?vue&type=script&lang=js"
export * from "./BaseUserForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports